import HomeIcon from "@mui/icons-material/Home";
import ListAltIcon from "@mui/icons-material/ListAlt";
import MenuIcon from "@mui/icons-material/Menu";
import {
    AppBar,
    Button,
    Box,
    Grid,
    IconButton,
    MenuItem,
    Paper,
    Select,
    SelectChangeEvent,
    Skeleton,
    styled,
    TextField
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../src/app/hooks";
import { useUserContext } from "./user-provider";
import { LOCAL_CONSTANT } from "./page/Const";
import {
    getLocationAdminUserCheck,
    getChangeLocationUser
} from "../src/utility/firestore";
import { authCheck, getUserDocument } from "../src/utility/firebase";
import { User } from "firebase/auth";


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#fff",
    ...theme.typography.h5,
    padding: theme.spacing(1),
    textAlign: "center",
    boxShadow: "none",
    border: "none",
}));

const headerStyle = {
    bgcolor: "white",
    position: "fixed",
    zIndex: 1250,
    boxShadow: "none",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
};

let userChangeMenu = {
    visibility: "hidden",
};

type Props = {
    toggleDrawer: () => void;
    userdata: {};
};

const AppHeader = ({ toggleDrawer, userdata }: Props) => {
    const location = useLocation();
    const user = useUserContext();
    const navigate = useNavigate();
    //ヘッダーオブジェクト
    const objAppHeader = useAppSelector((state) => state.appHeader);
    //ヘッダータイトル
    const [appTitle, setAppTitle] = useState("");
    //候補地情報
    const [planInfo, setPlanInfo] = useState("");
    //メニュースタイル
    const [iconVisible, setIconVisible] = useState("");
    //ローディングフラグ
    const [loadingFlg, setLoadingFlg] = useState(false);
    //候補地情報表示フラグ
    const [planInfoViewFlg, setPlanInfoViewFlg] = useState(false);
    //ユーザー切り替えメニュー表示フラグ(true = 表示　false = 非表示)
    const [userChangeFlag, setUserChangeFlag] = useState(false);
    //ユーザー切り替え テキストフィールドに入力されたstaff_number
    const [inputChangeUser, setInputChangeUser] = useState<string>("");
    //ユーザータイプ切り替え
    const [userValue, setUserValue] = useState("");
    //Firebase認証ユーザーに戻すフラグ 変更取り消しボタン時（true = 戻す）
    const [longinUserChangeFlag, setLoginUserChangeFlag] = useState<boolean>(false);

    //アプリのヘッダーオブジェクトの更新
    useEffect(() => {
        const planAreaId = objAppHeader.planAreaId; //候補地ID
        const planAreaName = objAppHeader.planAreaName; //候補地名
        const strPlanInfo = `　${planAreaName}\n（候補地No.${planAreaId}）`;
        setPlanInfo(strPlanInfo);
        setLoadingFlg(false);
    }, [objAppHeader]);

    //ヘッダータイトル切り分け
    useEffect(() => {
        //タイトル
        let strTitle = "";
        //スタイル
        let strVisible = "";
        //ローディング中
        setLoadingFlg(true);
        //タブタイトル
        const routeTitleMap: Record<string, string> = {
            "/": "ポータル",
            "/PortalReport": "ポータル",
            "/Portal/CircularHistory": "全回覧履歴",
            "/LongPage": "調査書",
            "/approval-5mcut": "承認",
            "/approval-survey": "承認",
            "/PdfSummary": "PDF一覧",
            "/CircularHistory": "回覧履歴",
            "/ItemChangeHistory": "変更履歴",
            "/EvaluateChangeHistory": "変更履歴",
            "/DeficiencyComment": "不備コメント",
            "/RequestComment": "依頼コメント",
        };
        document.title = routeTitleMap[location.pathname] ?? "立地評価デジタル";
        if (
            location.pathname === "/" ||
            location.pathname === "/PortalReport" ||
            location.pathname === "/Portal/CircularHistory"
        ) {
            strTitle = "立地調査書デジタル（ポータル）";
            strVisible = "hidden";
            setAppTitle(strTitle);
            setIconVisible(strVisible);
            setPlanInfoViewFlg(false);
        } else if (location.pathname === "/Color") {
            strTitle = "立地調査書（カラーサンプル）";
            strVisible = "visible";
            setAppTitle(strTitle);
            setIconVisible(strVisible);
            setPlanInfoViewFlg(false);
        } else {
            strTitle = "立地調査書デジタル（調査書）";
            strVisible = "visible";
            setAppTitle(strTitle);
            setIconVisible(strVisible);
            setPlanInfoViewFlg(false);
            if (location.pathname === "/LongPage"
                || location.pathname === "/ItemChangeHistory") {
                setPlanInfoViewFlg(true);
            }
        }
    }, [location.pathname]);

    //Homeボタン押下イベント
    const goTop = () => {
        const element = document.getElementById("naviDrawer");

        //サイドメニュー非表示
        if (element) {
            element.style.display = "none";
        }
        navigate("/");
    };

    //ユーザーデータ（RFC）
    const rfcData = {
        user_type: LOCAL_CONSTANT.USER_TYPE.RFC,
        department_code: "950404",
        department_code_OA: "950404",
        job_category_code: "403",
        job_category_code_OA: "360",
        top_department_code_OA: "950400",
        manage_steps: ["0", "1", "2", "3", "4", "5", "6", "8", "44", "99", "7"],
        firebase_id: "mHQqumoXO3hgRcqDswCigZsUV0H3",
        substitute_staff_number: "k000196",
        update_date: { _seconds: 1631668481, _nanoseconds: 652000000 },
        mode: "Administrator",
        a_test_flag: true,
        manage_plans_outside_cities: ["9f884cb2f8"],
        corporate_create_flag: "1",
        corporate_flag: "ALL",
        sales_display_flag: "1",
        daily_regist_plan_flag: "0",
        daily_regist_existing_flag: "0",
        daily_regist_owner_flag: "0",
        administrator_flag: "1",
        zone_strategy_flag: "1",
        manage_cities: ["13101", "13103", "13105", "ALL"],
        expansion_polygon_flag: "1",
        user_name: "RFCユーザー",
        email: "",
        staff_number: "s990099",
    };
    //ユーザーデータ（リサーチ）
    const rrData = {
        user_type: LOCAL_CONSTANT.USER_TYPE.RR,
        department_code: "992002",
        department_code_OA: "992002",
        job_category_code: "401",
        job_category_code_OA: "230",
        top_department_code_OA: "992000",
        manage_steps: ["0", "1", "2", "3", "4", "5", "6", "8", "44", "99", "7"],
        firebase_id: "mHQqumoXO3hgRcqDswCigZsUV0H3",
        substitute_staff_number: "k000196",
        update_date: { _seconds: 1631668481, _nanoseconds: 652000000 },
        mode: "Administrator",
        a_test_flag: true,
        manage_plans_outside_cities: ["9f884cb2f8"],
        corporate_create_flag: "1",
        corporate_flag: "ALL",
        sales_display_flag: "1",
        daily_regist_plan_flag: "0",
        daily_regist_existing_flag: "0",
        daily_regist_owner_flag: "0",
        administrator_flag: "1",
        zone_strategy_flag: "1",
        manage_cities: ["13101", "13103", "13105", "ALL"],
        expansion_polygon_flag: "1",
        user_name: "リサーチユーザー",
        email: "",
        staff_number: "s382444",
    };
    //ユーザーデータ（RM）
    const rmData = {
        user_type: LOCAL_CONSTANT.USER_TYPE.RM,
        department_code: "950652",
        department_code_OA: "950652",
        job_category_code: "401",
        job_category_code_OA: "230",
        top_department_code_OA: "950650",
        manage_steps: ["0", "1", "2", "3", "4", "5", "6", "8", "44", "99", "7"],
        firebase_id: "mHQqumoXO3hgRcqDswCigZsUV0H3",
        substitute_staff_number: "k000196",
        update_date: { _seconds: 1631668481, _nanoseconds: 652000000 },
        mode: "Administrator",
        a_test_flag: true,
        manage_plans_outside_cities: ["9f884cb2f8"],
        corporate_create_flag: "1",
        corporate_flag: "ALL",
        sales_display_flag: "1",
        daily_regist_plan_flag: "0",
        daily_regist_existing_flag: "0",
        daily_regist_owner_flag: "0",
        administrator_flag: "1",
        zone_strategy_flag: "1",
        manage_cities: ["13101", "13103", "13105", "ALL"],
        expansion_polygon_flag: "1",
        user_name: "RMユーザー",
        email: "",
        staff_number: "",
    };
    //ユーザーデータ（GM）
    const gmData = {
        user_type: LOCAL_CONSTANT.USER_TYPE.GM,
        department_code: "950650",
        department_code_OA: "950650",
        job_category_code: "401",
        job_category_code_OA: "101",
        top_department_code_OA: "950000",
        manage_steps: ["0", "1", "2", "3", "4", "5", "6", "8", "44", "99", "7"],
        firebase_id: "mHQqumoXO3hgRcqDswCigZsUV0H3",
        substitute_staff_number: "k000196",
        update_date: { _seconds: 1631668481, _nanoseconds: 652000000 },
        mode: "Administrator",
        a_test_flag: true,
        manage_plans_outside_cities: ["9f884cb2f8"],
        corporate_create_flag: "1",
        corporate_flag: "ALL",
        sales_display_flag: "1",
        daily_regist_plan_flag: "0",
        daily_regist_existing_flag: "0",
        daily_regist_owner_flag: "0",
        administrator_flag: "1",
        zone_strategy_flag: "1",
        manage_cities: ["13101", "13103", "13105", "ALL"],
        expansion_polygon_flag: "1",
        user_name: "GMユーザー",
        email: "",
        staff_number: "",
    };
    //ユーザーデータ（その他）
    const etcData = {
        user_type: LOCAL_CONSTANT.USER_TYPE.OTHER,
        department_code: "950801",
        department_code_OA: "950801",
        job_category_code: "401",
        job_category_code_OA: "550",
        top_department_code_OA: "950000",
        manage_steps: ["0", "1", "2", "3", "4", "5", "6", "8", "44", "99", "7"],
        firebase_id: "mHQqumoXO3hgRcqDswCigZsUV0H3",
        substitute_staff_number: "k000196",
        update_date: { _seconds: 1631668481, _nanoseconds: 652000000 },
        mode: "Administrator",
        a_test_flag: true,
        manage_plans_outside_cities: ["9f884cb2f8"],
        corporate_create_flag: "1",
        corporate_flag: "ALL",
        sales_display_flag: "1",
        daily_regist_plan_flag: "0",
        daily_regist_existing_flag: "0",
        daily_regist_owner_flag: "0",
        administrator_flag: "1",
        zone_strategy_flag: "1",
        manage_cities: ["13101", "13103", "13105", "ALL"],
        expansion_polygon_flag: "1",
        user_name: "その他ユーザー",
        email: "",
        staff_number: "",
    };

    //ユーザータイププルダウン変更
    // ユーザー情報を変更、ローカルストレージにセット
    const changeUserSelect = (e: SelectChangeEvent) => {
        const val = e.target.value;
        setUserValue(e.target.value)
        if (user.setUserData) {
            if (val === "1") {
                setInputChangeUser(rfcData.staff_number);
                user.setUserData(JSON.stringify(rfcData));
                localStorage.setItem("userInfo", JSON.stringify(rfcData));
            } else if (val === "2") {
                setInputChangeUser(rrData.staff_number);
                user.setUserData(JSON.stringify(rrData));
                localStorage.setItem("userInfo", JSON.stringify(rrData));
            } else if (val === "3") {
                setInputChangeUser(rmData.staff_number);
                user.setUserData(JSON.stringify(rmData));
                localStorage.setItem("userInfo", JSON.stringify(rmData));
            } else if (val === "4") {
                setInputChangeUser(gmData.staff_number);
                user.setUserData(JSON.stringify(gmData));
                localStorage.setItem("userInfo", JSON.stringify(gmData));
            } else if (val === "5") {
                setInputChangeUser(etcData.staff_number);
                user.setUserData(JSON.stringify(etcData));
                localStorage.setItem("userInfo", JSON.stringify(etcData));
            }
            // ユーザー切り替えを空
            setInputChangeUser("");
        }
    };

    //特別なユーザーの場合 ユーザータイプ変更、変更、変更取り消しを表示
    useEffect(() => {
        (async () => {
            const authUser = await authCheck();
            if (authUser) {
                const userdata = authUser as User;
                const isAdminStaff = await getLocationAdminUserCheck(userdata.uid);
                const userdoc = await getUserDocument(userdata.uid, userdata.email);
                // 変更取り消しボタン実行時はログインしたユーザーに戻す
                if (longinUserChangeFlag) {
                    if (user.setUserData) {
                        user.setUserData(userdoc || "null");
                        setLoginUserChangeFlag(false);
                    }
                }
                if (isAdminStaff) {
                    setUserChangeFlag(true);
                }
            }
        })();
    }, [user, longinUserChangeFlag]);

    // 画面右上にユーザータイプを設定、ローカルストレージにユーザー情報がstaff_numberが存在すれば表示
    useEffect(() => {    
        const userData = JSON.parse(user.userData || "null");
        if (userData !== null) {
            setUserValue(getUserValueByType(userData.user_type));
            // ローカルストレージのuserInfoを取得
            const userInfo = localStorage.getItem("userInfo");
            // ローカルストレージにあればstaff_numberを設定
            if (userInfo && userData.staff_number) {
                setInputChangeUser(userData.staff_number);
            }
        }
    }, [user]);

    //文字列分割関数
    const breakedText = (text: string) => {
        return text.split("\n").map((line, key) => (
            <span key={key}>
                {line}
                <br />
            </span>
        ));
    };

    // ユーザータイプから表示値を返す関数
    const  getUserValueByType = (userType: string) => {
        switch (userType) {
            case LOCAL_CONSTANT.USER_TYPE.RFC:
                return "1";
            case LOCAL_CONSTANT.USER_TYPE.RR:
                return "2";
            case LOCAL_CONSTANT.USER_TYPE.RM:
                return "3";
            case LOCAL_CONSTANT.USER_TYPE.GM:
                return "4";
            case LOCAL_CONSTANT.USER_TYPE.OTHER:
                return "5";
            default:
                return "";
        }
    };

    //ユーザー切り替え テキストフィールド
    const handleInputChangeStaffNumber = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setInputChangeUser(e.target.value);
    };

    //変更ボタン ユーザー切り替え
    const handleClickChangeStaffNumber = () => {
        (async () => {
            const userInfoObject = await getChangeLocationUser(inputChangeUser);
            if (userInfoObject && Object.keys(userInfoObject).length > 0) {
                // ユーザーがいればローカルストレージにセット
                localStorage.setItem("userInfo", JSON.stringify(userInfoObject));
                if (user.setUserData) {
                    user.setUserData(JSON.stringify(userInfoObject));
                }
            } else {
                // ユーザーが存在しない場合はローカルストレージから削除
                localStorage.removeItem("userInfo");
                // ユーザータイプを空
                setUserValue("");
                // ユーザー切り替えを空
                setInputChangeUser("");
            }
        })();
    };
    
    //変更取り消しボタン
    const handleClickCancelStaffNumber = () => {
        // ローカルストレージから削除
        localStorage.removeItem("userInfo");
        // ユーザー切り替えを空
        setInputChangeUser("");
        // Firebase認証ユーザーに戻すフラグを設定
        setLoginUserChangeFlag(true);
    }


    return (
        <AppBar component="header" position="sticky" sx={headerStyle}>
            <Grid
                columns={24}
                container
                justifyContent="space-between"
                alignItems="center"
                flexDirection={{ xs: "row" }}
            >
                <Grid container alignItems="center">
                    {/* 【立地調査リリース後対応】5m外、商圏カット承認用ページ */}
                    {/* {
                        location.pathname === "/approval-5mcut" &&
                        <Grid item xs={0.5} sx={{ textAlign: "center" }}></Grid>
                    } */}
                    {
                        (
                            window.location.pathname == "/LongPage" ||
                            window.location.pathname == "/CircularHistory" ||
                            window.location.pathname == "/ItemChangeHistory"
                        ) && (
                            <Grid item xs={0.5} sx={{ textAlign: "center" }}>
                                <IconButton
                                    sx={{ visibility: iconVisible }}
                                    onClick={toggleDrawer}
                                >
                                    <MenuIcon sx={{ padding: "3px" }} />
                                </IconButton>
                            </Grid>
                        )
                    }
                    {
                        (
                            window.location.pathname !== "/LongPage" &&
                            window.location.pathname !== "/CircularHistory" &&
                            window.location.pathname !== "/ItemChangeHistory"
                        ) && (
                            <Grid item xs={0.5} sx={{ textAlign: "center" }}></Grid>
                        )
                    }
                    <Grid item xs={3.5}>
                        <Item sx={{ float: "left" }}>{appTitle}</Item>
                    </Grid>
                    <Grid item xs={4.5}>
                        {planInfoViewFlg && (
                            <Item sx={{ float: "left", fontSize: "15px" }}>
                                {loadingFlg ? (
                                    <Skeleton width={350} />
                                ) : (
                                    breakedText(planInfo)
                                )}
                            </Item>
                        )}
                    </Grid>
                    {location.pathname !== "/Color" && userChangeFlag ? (
                            <Grid item xs={2.7}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Select
                                        label="User"
                                        onChange={changeUserSelect}
                                        sx={{ height: "60%" }}
                                        value={userValue}
                                    >
                                        <MenuItem value={""}>　</MenuItem>
                                        <MenuItem value={"1"}>RFC</MenuItem>
                                        <MenuItem value={"2"}>リサーチ</MenuItem>
                                        <MenuItem value={"3"}>RM</MenuItem>
                                        <MenuItem value={"4"}>GM</MenuItem>
                                        <MenuItem value={"5"}>その他</MenuItem>
                                    </Select>
                                    <TextField
                                        sx={{ width:"95px" }}
                                        value={inputChangeUser}
                                        onChange={(e) => { handleInputChangeStaffNumber(e) }}
                                    />
                                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                                        <Button sx={{ fontSize: "12px", padding: "3px 4px" }} onClick={() => { handleClickChangeStaffNumber() }}>
                                            変更
                                        </Button>
                                        <Button sx={{ fontSize: "12px", padding: "3px 4px" }} onClick={() => { handleClickCancelStaffNumber()}}>
                                            変更取り消し
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                    ) : (
                        <Grid item xs={2} sx={{ visibility: "hidden" }}></Grid>
                    )}
                    {location.pathname !== "/Color" && (
                        <>
                            <Grid item xs={0.3} sx={{ textAlign: "center" }}>
                                <Button onClick={goTop}>
                                    <HomeIcon sx={{ padding: "3px" }} />
                                </Button>
                            </Grid>
                            <Grid item xs={0.3} sx={{ textAlign: "center" }}>
                                <Button>
                                    <ListAltIcon sx={{ padding: "3px" }} />
                                </Button>
                            </Grid>
                        </>
                    )}
                </Grid>
            </Grid>
        </AppBar>
    );
};

export default AppHeader;
